import { useFormikContext } from "formik";
import { useEffect, useMemo } from "react";
import {
  copyPuntoAddress,
  isModalidadRecorridoLocked,
  syncPuntosModalidadRetorno,
} from "./fptTrasladosUtils";

const ModalidadRetornoSync = ({
  modalidades,
  disabled = false,
  idEstadoInicial = null,
  isRepeatForm = false,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const originSignature = useMemo(
    () => JSON.stringify(copyPuntoAddress(values.puntos?.[0] || {})),
    [values.puntos?.[0]],
  );

  useEffect(() => {
    if (disabled || (!isRepeatForm && isModalidadRecorridoLocked(values.puntos))) return undefined;
    const nextPuntos = syncPuntosModalidadRetorno(
      values.puntos,
      modalidades,
      values.idModalidad,
      values.tramosDefaults,
      idEstadoInicial,
    );
    if (nextPuntos !== values.puntos) {
      setFieldValue("puntos", nextPuntos, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    disabled,
    idEstadoInicial,
    isRepeatForm,
    modalidades,
    originSignature,
    values.idModalidad,
  ]);

  return null;
};

export default ModalidadRetornoSync;
